<template>
  <div>
    <div v-if="difference.type === 1"><!-- 新增合同 -->
      <ul>
        <li class="record-row">
          <span>新增合同</span>
        </li>
      </ul>

    </div>
    <div v-if="difference.type === 2"><!-- 修改合同 -->
      <ul v-if="!showDifferenceContract && !showDifferenceContractItems && !showDifferenceContractTerms">
        <li>待修改</li>
      </ul>
      <ul v-if="showDifferenceContract">
        <li v-for="item in difference.contract" :key="item.name" class="record-row">
          {{item.label}}：“<span class="update">{{item.previous}}</span>” 改为了 “<span class="update">{{item.current}}</span>”
        </li>
      </ul>
      <ul v-if="showDifferenceContractItems">
        <li v-if="showAddContractItems"  class="record-row">
          <span>计费项添加了：</span>
          <span v-for="item in difference.contractItems.adds" :key="item.uuid">
          <span class="add">
            {{item.name}}&nbsp;&nbsp;
          </span>
        </span>
        </li>
        <li v-if="showDeleteContractItems"  class="record-row">
          <span>计费项删除了：</span>
          <span v-for="item in difference.contractItems.deletes" :key="item.uuid">
          <span class="delete">
            {{item.name}}&nbsp;&nbsp;
          </span>
        </span>
        </li>
        <li v-if="showUpdateContractItems"  class="update-record-row">
          <span style="line-height: 60px;">计费项修改了：</span>
          <div v-for="item in difference.contractItems.updates" :key="item.data.uuid">
            {{item.data.name}}
            <ul>
              <li v-for="change in item.changes" :key="change.name">
                {{change.label}}：“<span class="update">{{change.previous}}</span>” 改为了 “<span class="update">{{change.current}}</span>”
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <ul v-if="showDifferenceContractTerms">
        <li v-if="showAddContractTerms"  class="record-row">
          <span>账单类型设置添加了：</span>
          <span v-for="item in difference.contractTerms.adds" :key="item.uuid">
          <span class="add">
            {{item.name}}&nbsp;&nbsp;
          </span>
        </span>
        </li>
        <li v-if="showDeleteContractTerms"  class="record-row">
          <span>账单类型设置删除了：</span>
          <span v-for="item in difference.contractTerms.deletes" :key="item.uuid">
          <span class="delete">
            {{item.name}}&nbsp;&nbsp;
          </span>
        </span>
        </li>
        <li v-if="showUpdateContractTerms"  class="update-record-row">
          <span style="line-height: 60px;">账单类型设置修改了：</span>
          <div v-for="item in difference.contractTerms.updates" :key="item.data.uuid">
            {{item.data.name}}
            <ul>
              <li v-for="change in item.changes" :key="change.name">
                {{change.label}}：“<span class="update">{{change.previous}}</span>” 改为了 “<span class="update">{{change.current}}</span>”
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "contract-record-difference",
  props: {
    difference: {
      default() {
        return {
          type: 1,
          contract: [],
          contractItems: {
            adds: [],
            updates: [],
            deletes: [],
          },
        };
      }
    }
  },
  computed: {
    showDifferenceContract() {
      return this.difference.contract.length > 0;
    },
    showDifferenceContractItems() {
      return this.showAddContractItems || this.showDeleteContractItems || this.showUpdateContractItems;
    },
    showAddContractItems() {
      return this.difference.contractItems.adds != null && this.difference.contractItems.adds.length > 0;
    },
    showDeleteContractItems() {
      return this.difference.contractItems.deletes != null && this.difference.contractItems.deletes.length > 0;
    },
    showUpdateContractItems() {
      return this.difference.contractItems.updates != null && this.difference.contractItems.updates.length > 0;
    },
    showDifferenceContractTerms() {
      return this.showAddContractTerms || this.showDeleteContractTerms || this.showUpdateContractTerms;
    },
    showAddContractTerms() {
      return this.difference.contractTerms.adds != null && this.difference.contractTerms.adds.length > 0;
    },
    showDeleteContractTerms() {
      return this.difference.contractTerms.deletes != null && this.difference.contractTerms.deletes.length > 0;
    },
    showUpdateContractTerms() {
      return this.difference.contractTerms.updates != null && this.difference.contractTerms.updates.length > 0;
    },
  },
}
</script>

<style scoped>
.add {
  color: #66cc66;
  font-weight: bold;
}
.update {
  color: #E6A23C;
  font-weight: bold;
}
.delete {
  color: #FF0000;
  font-weight: bold;
}
.record-row {
  min-height: 60px;
  line-height: 60px;
  /*border-bottom:1px dotted #E4E4E4;*/
}
.update-record-row {
  min-height: 30px;
  line-height: 30px;
  /*border-bottom: 1px dotted #E4E4E4;*/
}
</style>
